var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FE8205",
    d: "M39.998 0c3.781 0 7.561 1.888 9.777 5.66l28.573 48.647C82.923 62.097 77.456 72 68.574 72H11.427C2.55 72-2.925 62.102 1.652 54.307L30.226 5.66C32.443 1.885 36.221 0 39.998 0",
    transform: "translate(0 3.333)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA624B",
    d: "M67.799 54.307L39.789 5.66C38.58 3.558 36.894 2.044 35 1.113 36.508.373 38.15 0 39.792 0c3.703 0 7.406 1.885 9.58 5.66L77.38 54.307C81.867 62.102 76.5 72 67.8 72h-9.582c8.702 0 14.069-9.898 9.582-17.693z",
    opacity: 0.505,
    transform: "translate(0 3.333)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M5.8 0C2.285 0 1.636 4.289 1.83 8.706l.537 15.635c.76 4.885 6.106 4.873 6.864 0L9.77 8.706C9.964 3.94 9.316 0 5.799 0z",
    transform: "translate(0 3.333) matrix(-1 0 0 1 46 23.333)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6EDF3",
    d: "M6.186 24.343L5.483 8.707C5.29 5.34 5.738 2.05 8 .674 7.281.241 6.374 0 5.238 0 .636 0-.215 4.289.041 8.707l.702 15.636c.738 3.619 4.77 4.548 7.215 2.805-.854-.608-1.515-1.542-1.772-2.805z",
    transform: "translate(0 3.333) matrix(-1 0 0 1 46 23.333)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 3.333) matrix(-1 0 0 1 45 55.333)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6EDF3",
    d: "M4.2 4c0-1.416.718-2.658 1.8-3.37C5.394.233 4.673 0 3.9 0 1.746 0 0 1.79 0 4s1.746 4 3.9 4c.773 0 1.494-.232 2.1-.63C4.918 6.657 4.2 5.415 4.2 4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.4db53ee11ba14b8385a471b14ff503e4.svg";
export { ForwardRef as ReactComponent };